import { Button as e } from "../../button/primitive/button.js";
import { breakpointQueries as t } from "../../shared/breakpoints.js";
import { useMediaQuery as n } from "../../shared/hooks/use-media-query.js";
import { ChevronLeftIcon as r, ChevronRightIcon as i } from "@systemeio/icons";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/date-picker/primitive/date-picker-header.tsx
function s({ date: s, decreaseMonth: c, increaseMonth: l, intlLocale: u, hidePrevButton: d, hideNextButton: f, nextMonthButtonDisabled: p, prevMonthButtonDisabled: m }) {
	let h = n(t.isMobile, { initializeWithValue: !1 });
	return /* @__PURE__ */ o("div", {
		className: "border-border-200 tablet:border-b flex items-center justify-between p-4 pt-5",
		children: [
			d ? /* @__PURE__ */ a("span", {}) : /* @__PURE__ */ a(e, {
				"aria-label": "Previous month",
				size: h ? "icon-md" : "icon-xs",
				variant: "ghost-gray",
				disabled: m,
				onClick: c,
				children: /* @__PURE__ */ a(r, {})
			}),
			/* @__PURE__ */ a("span", {
				className: "text-text-secondary tablet:text-base text-lg font-normal",
				children: new Intl.DateTimeFormat(u, {
					month: "long",
					year: "numeric"
				}).format(s)
			}),
			f ? /* @__PURE__ */ a("span", {}) : /* @__PURE__ */ a(e, {
				"aria-label": "Next month",
				size: h ? "icon-md" : "icon-xs",
				variant: "ghost-gray",
				disabled: p,
				onClick: l,
				children: /* @__PURE__ */ a(i, {})
			})
		]
	});
}
//#endregion
export { s as DatePickerHeader };
